import * as p from './positions'
import { cssColors as colors } from './colors'

const culture = 'culture'
const economy = 'economy'
const social = 'social'
const housing = 'housing'
const hood = 'hood'
const youth = 'youth'

export const sections = {
  CULTURE: culture,
  ECONOMY: economy,
  SOCIAL: social,
  HOUSING: housing,
  HOOD: hood,
  YOUTH: youth
}

export const sectionMembers = {
  [sections.CULTURE]: ['reitschule', 'dampfzentrale', 'club111', 'kunstkanal'],
  [sections.ECONOMY]: [
    'brasserie-lorraine',
    'velokurier',
    'manus',
    'velowerkstatt',
    'hallerladen',
    'wylereggladen',
    'treuhandburoTis',
    'vorsorgestiftungGepabu'
  ],
  [sections.SOCIAL]: ['sleeper', 'gassenarbeit', 'xenia', 'fixerstubli'],
  [sections.HOUSING]: [
    'giebel',
    'qHof',
    'murifeld',
    'zaffaraya',
    'viaFelsenau',
    'aarestrand'
  ],
  [sections.HOOD]: ['breitschTraff', 'villaStucki', 'labigiLorraine'],
  [sections.YOUTH]: [
    'bronx',
    'juko',
    'spielewerkstatt',
    'schutzenweg',
    'graffiti'
  ]
}

export const institutions = [
  // culture
  {
    name: 'reitschule',
    address: 'Neubrückstrasse 8, 3012 Bern',
    displayName: 'Reitschule',
    positions: p.reitschulePositions,
    color: colors.FIRST,
    image: p.reitschulePositions[0].imgSrc,
    text:
      'Die Reitschule wurde erstmals im Oktober 1981 als «Autonomes Begegnungszentrum» in Betrieb genommen. Es entsprach einer Forderung der Bewegung nach einem selbstverwalteten Kulturhaus. Allerdings folgte im April 1982 bereits die polizeiliche Räumung. <br /> <br /> Im Oktober 1987, während des sogenannten «heissen Herbsts» mit zahlreichen Demonstrationen, Strassenschlachten und illegalen Konzertabenden wurde die Reitschule erneut und nun dauerhaft besetzt. Seit 1993 verfügt die Reitschule über einen Nutzungsvertrag mit der Stadt, der per 1. Januar 2004 von einem Leistungsvertrag abgelöst wurde. Noch immer sind die zahlreichen Kulturräume und das Zentrum als Ganzes selbstverwaltet. Quelle: Verschiedene'
  },
  {
    name: 'dampfzentrale',
    address: 'Marzilistrasse 47, 3005 Bern',
    displayName: 'Dampfzentrale',
    positions: p.dampfzentralePositions,
    color: colors.SECOND,
    image: p.dampfzentralePositions[0].imgSrc,
    text:
      'Künstlerinnen und Künstler aus der freien Tanz- und Theaterszene gründeten 1986 den Verein Dampfzentrale. Sie forderten die kulturelle Nutzung der Räumlichkeiten an der Aare, weil Auftrittsorte fehlten. Um der Forderung Nachdruck zu verleihen, wurde im Mai 1987 die Dampfzentrale für eine Nacht besetzt - woran noch heute ein Züri-West-Song erinnert.<br /> <br /> Am 19. 10. 1987 bewilligte der bürgerliche Gemeinderat den Versuchsbetrieb. Mittlerweile hat die Dampfzentrale an Niederschwelligkeit eingebüsst, verfügt über professionelle Strukturen, ein hochkarätiges Kulturprogramm und reichlich Subventionen der Stadt. Quelle: <a href="https://www.dampfzentrale.ch" target="_blank">dampfzentrale.ch</a>'
  },
  {
    name: 'club111',
    address: 'Unterer Aareggweg 11, 3004 Bern',
    displayName: 'Club 111',
    positions: p.club111Positions,
    color: colors.THIRD,
    image: p.club111Positions[0].imgSrc,
    text:
      '1989 gründen Meret Matter, Grazia Pergoletti und Ruth Schwegler den Club 111. Die Gründung stand in Zusammenhang mit der Reitschul-Besetzung, die ersten Proben fanden im Tojo des Kulturzentrums statt. Sie wurde unter anderem damit begründet, dass Theaterschauspielerinnen wenig abwechslungsreiche Rollen zugesprochen bekamen. Mit dem Club 111 realisierten eine wachsende und schwankende Anzahl Mitglieder verschiedene Stücke - bis heute. Quelle: derbund.ch'
  },
  {
    name: 'kunstkanal',
    address: 'Wylerringstrasse 7, 3014 Bern',
    displayName: 'Kunstkanal',
    positions: p.kunstkanalPositions,
    color: colors.FOURTH,
    image: p.kunstkanalPositions[0].imgSrc,
    text:
      'In den 1980er-Jahren, zur Zeit der Jugendunruhen, entstand der Kunstkanal aus der Notwendigkeit heraus, unabhängig vom Kunstestablishment aktuelle Kunst zu kreieren. Statt in kommerziellen Galerien oder in den White Cubes der ehrwürdigen musealen Hallen, wollten die Kunstschaffenden der neuen Generation ihre Kunst in leerstehenden Fabriken, Abbruchobjekten und auf der Strasse zeigen, um so das konventionelle und etablierte System der Kunstvermittlung und der Kunstproduktion zu unterlaufen. <br /> <br /> Die Künstler besetzten leerstehende Häuser und mieteten sich in Abbruchobjekte zu erschwinglichen Konditionen temporär ein. Bei jedem Umzug in eine neue Liegenschaft kam es zu Änderungen in der jeweiligen Zusammensetzung der Atelierbewohner. Die Auswahl der Mitbewohner trafen die Kunstschaffenden im Kollektiv. Heute vermietet der Kunstkanal an der Wylerringstrasse 7 mehrere Ateliers. Quelle <a href="https://www.kunstkanal.ch" target="_blank">kunstkanal.ch</a>'
  },

  // economy
  {
    name: 'brasserie-lorraine',
    address: 'Quartiergasse 17, 3013 Bern',
    displayName: 'Brasserie Lorraine',
    positions: p.brasserieLorrainePositions,
    color: colors.FIRST,
    image: p.brasserieLorrainePositions[0].imgSrc,
    text:
      '1980 kaufte die im Vorjahr gegründete Genossenschaft Kukuz (Kulinarisches Kulturzentrum) die Liegenschaft in der Lorraine, um eine kollektiv geführte Genossenschaftsbeiz zu eröffnen. Die im November 1981 eröffnete Beiz entwickelte sich rasch zum Quartierschreck und bis zur Reitschul-Besetzung 1987 zum wichtigsten Treffpunkt der linken Szene in Bern. Noch heute wird das Restaurant kollektiv – also ohne Chef – geführt. Quelle: <a href="https://www.brasserie-lorraine.ch" target="_blank">brasserie-lorraine.ch</a>'
  },
  {
    name: 'velokurier',
    address: 'Dammweg 41, 3013 Bern',
    displayName: 'Velokurier',
    positions: p.velokurierPositions,
    color: colors.SECOND,
    image: p.velokurierPositions[0].imgSrc,
    text:
      'Am 6. Oktober 1988 starteten die ersten beiden Velokuriere Berns zu ihren allerersten Fahrten. Heute sind über 60 Frauen und Männer auf der Strasse unterwegs oder in der Disposition, dem Büro und der Küche tätig. Die selbstverwaltete Genossenschaft ist bis heute von hunderten von Kurieren und Kurierinnen aufgebaut worden. Um den durchschnittlichen CO2-Ausstoss pro Sendung möglichst tief zu halten, sind sie ohne Elektro- und ohne Verbrennungsmotor unterwegs. Quelle: <a href="https://www.velokurierbern.ch" target="_blank">velokurierbern.ch</a>'
  },
  {
    name: 'manus',
    address: 'Güterstrasse 51, 3008 Bern',
    displayName: 'Manus Bau + Schreinerei',
    positions: p.manusPositions,
    color: colors.THIRD,
    image: p.manusPositions[0].imgSrc,
    text:
      'Die Firma wurde 1982 als Genossenschaft und Baukollektiv gegründet. Das Ziel war, baubiologisch und ökologisch zu Bauen und ebensolche Möbel und Produkte herzustellen. <br /> <br /> Mittlerweile wurden die Strukturen zwar professionalisiert, doch der Team-Gedanke wie auch das ökologische Bauen sind nach wie vor Teil der Philosophie des Unternehmens. Quelle: <a href="https://www.manusbern.ch" target="_blank">manusbern.ch</a>'
  },
  {
    name: 'velowerkstatt',
    address: 'Turnweg 20, 3013 Bern',
    displayName: 'Velowerkstatt',
    positions: p.velowerkstattPositions,
    color: colors.FOURTH,
    image: p.velowerkstattPositions[0].imgSrc,
    text:
      'Der Verein Velowärchstatt wurde 1981 mit dem Ziel gegründet, den Velofahrenden innerhalb des stark zunehmenden Autoverkehrs zu der nötigen Beachtung zu verhelfen. Da dies in Zeiten der Regentschaft von Verkehrsdirektorin Ursula Wyss (SP) an Dringlichkeit verloren hat, legt die Velowerkstatt vermehrt Wert darauf, Dienstleistungen für ihre Mitglieder anzubieten. (Quelle: <a href="https://www.velowaerchstatt.ch" target="_blank">velowaerchstatt.ch</a>)'
  },
  {
    name: 'hallerladen',
    address: 'Länggassstrasse 30, 3012 Bern',
    displayName: 'Hallerladen',
    positions: p.hallerladenPositions,
    color: colors.FIFTH,
    image: p.hallerladenPositions[0].imgSrc,
    text:
      'Eine Gruppe linker Studenten um Michael Kaufmann ergreift 1980 die Gelegenheit, ihre Zukunftsvisionen in einem Projekt zu bündeln: Sie übernimmt den kleinen Milchladen an der Hallerstrasse 1 im Berner Länggassquartier mit dem Ziel, Bio-Produkte zu verkaufen und zu propagieren und die Menschen über Bio-Landbau zu informieren. <br /> <br /> Mittlerweile befindet sich der Hallerladen an der Länggassstrasse, ist aber noch immer genossenschaftlich organisiert und verkauft weiterhin Bio- und Fair-Trade-Produkte. Quelle: <a href="http://www.hallerladen.ch/" target="_blank">hallerladen.ch</a>'
  },
  {
    name: 'wylereggladen',
    address: 'Wylerstrasse 49, 3014 Bern',
    displayName: 'Wylereggladen',
    positions: p.wylereggladenPositions,
    color: colors.SIXTH,
    image: p.wylereggladenPositions[0].imgSrc,
    text:
      'Die Geschichte des seit 1983 bestehenden Wylereggladens ist ereignis- und abwechslungsreich. Aus dem revolutionären selbstverwalteten Lebensmittelladen ist ein gepflegter und moderner Bio-, Quartier- und Weltladen geworden, der zwar seine Strukturen verändert hat, aber seinen Prinzipien und Idealen treu geblieben ist. Quelle: <a href="https://www.wylereggladen.ch" target="_blank">wylereggladen.ch</a>'
  },
  {
    name: 'weltladen',
    address: 'Rathausgasse 52, 3011 Bern',
    displayName: 'Weltladen Bern',
    positions: p.weltladenPositions,
    color: colors.SEVENTH,
    image: p.weltladenPositions[0].imgSrc,
    text:
      'Der Weltladen Bern war 1981 der erste entsprechende Laden der Schweiz mit Angestellten. Er setzte von Beginn an auf fair gehandelte Produkte, die er anfänglich vor allem an Märitständen und kleinen Verkaufsnischen an verschiedenen Orten veräusserte. Erst 1990 bekam er an der Rathausgasse 52 ein eigenes Ladenlokal, damals allerdings im Keller. Quelle: <a href="http://mit-leidenschaft.ch/" target="_blank">mit-leidenschaft.ch'
  },
  {
    name: 'treuhandburoTis',
    displayName: 'Treuhandbüro Tis',
    address: 'Morgenstrasse 70, 3018 Bern',
    positions: p.treuhandburoTisPositions,
    color: colors.EIGTH,
    image: p.treuhandburoTisPositions[0].imgSrc,
    text:
      'Das Treuhandbüro Tis wurde 1981 von Günther Ketterer und Carola Ertle gegründet und 1995 in eine GmbH umgewandelt. Obwohl es von der Rechtsform her gängigen Firmen entspricht, entwickelte es sich aufgrund des Netzwerks und der Überzeugung des Gründers zum Treuhänder von Berns Alternativszene. Zu den Kunden zählen und zählten Wohnbaugenossenschaften, die Wochenzeitung, die Brasserie Lorraine, der Weltladen und verschiedene Kunstateliers. Quelle: <a href="https://www.treuhandtis.ch" target="_blank">treuhandtis.ch</a>'
  },
  {
    name: 'vorsorgestiftungGepabu',
    address: 'Weyermansstrasse 28, 3008 Bern',
    displayName: 'Vorsorgestiftung Gepabu',
    positions: p.vorsorgestiftungGepabuPositions,
    color: colors.NINTH,
    image: p.vorsorgestiftungGepabuPositions[0].imgSrc,
    text:
      'Die Gepabu wurde 1981 gegründet und grenzt sich von anderen Personalvorsorgestiftungen mit ihren sozialen Grundwerten ab: Ethisch vertretbare Aktien- oder Obligationenanlagen, faire Mieten in ihren Wohnimmobilien und faire Zinskonditionen für die Hypothekennehmer. Sie investiert(e) in zahlreiche Genossenschaftsprojekte im Raum Bern. Quelle: <a href="https://www.gepabu.ch" target="_blank">gepabu.ch</a>'
  },

  // social
  {
    name: 'sleeper',
    address: 'Neubrückstrasse 19, 3012 Bern',
    displayName: 'Sleeper',
    positions: p.sleeperPositions,
    color: colors.FIRST,
    image: p.sleeperPositions[0].imgSrc,
    text:
      'Im Jahr 1981 wurde die Notschlafstelle «von Punks für Punks» an der Hodlerstrasse gegründet. Sie besetzten damals das ehemalige Hotel an der Hodlerstrasse 22 gegenüber der Schützenmatte. 1997 muss die Notschlafstelle das Haus an der Hodlerstrasse gänzlich räumen, weil die Stadt hier ihre neue Drogenanlaufstelle aufbauen wollte - und tat. Obwohl die Stadt dem Verein den Subventions- und den Mietvertrag kündigte, suchten die Betreiber auf eigene Faust nach einem neuen Heim. So zog der Sleeper 1998 an die Neubrückstrasse 19. Zum Sleeper gehört auch eine Gassenküche sowie die Bar Dead End, deren Einnahme in die Küche des Sleepers fliessen. Quelle: <a href="https://www.digezz.ch/von-randstaendigen-fuer-randstaendige/" target="_blank">digezz.ch</a>'
  },
  {
    name: 'gassenarbeit',
    address: 'Speichergasse 8, 3011 Bern',
    displayName: 'Gassenarbeit',
    positions: p.gassenarbeitPositions,
    color: colors.SECOND,
    image: p.gassenarbeitPositions[0].imgSrc,
    text:
      'Der Verein kirchliche Gassenarbeit wurde 1988 vom Zusammenschluss der reformierten Kirchgemeinden und der katholischen Gesamtkirchgemeinden gegründet. Es war nicht zuletzt eine Reaktion auf die Jugendunruhen der 80er-Jahre. Der Verein leistete Überlebenshilfe und bot Beratungen an und verzichtete auf Abstinenzorientierung. Er setzt sich nach wie vor für Drogensüchtige und Randständige ein. Quelle: <a href="https://www.gassenarbeit-bern.ch" target="_blank">Gassenarbeit Bern</a>'
  },
  {
    name: 'xenia',
    address: 'Langmauerweg 1, 3011 Bern',
    displayName: 'Xenia Bern',
    positions: p.xeniaPositions,
    color: colors.THIRD,
    image: p.xeniaPositions[0].imgSrc,
    text:
      'Der Verein Xenia wurde 1984 mit dem Ziel gegründet, die Akzeptanz der Bevölkerung für die Sexarbeit zu fördern und die Arbeitsbedingungen der Prostituierten zu verbessern. Die Beratungsstelle nahm ihre Arbeit 1986 auf, nachdem eine Bedürfnisabklärung gemacht wurde und jeweils einmal wöchentlich ein Treffpunkt für Sexarbeitende angeboten wurde. Bis 2009 war der Verein nur für die Sexarbeitende der Stadt Bern zuständig.<br /> <br /> Heute hat sich das Tätigkeitsfeld des Vereins XENIA erweitert: Die Fachstelle ist für den gesamten Kanton verantwortlich und hat seit 2010 einen Leistungsvertrag mit dem Kanton Bern. Quelle: <a href="https://www.xeniabern.ch" target="_blank">Xenia Bern</a>'
  },
  {
    name: 'fixerstubli',
    address: 'Hodlerstrasse 22, 3011 Bern',
    displayName: 'Fixerstübli',
    positions: p.fixerstubliPositions,
    color: colors.FOURTH,
    image: p.fixerstubliPositions[0].imgSrc,
    text:
      'Das Fixerstübli wurde von der Stiftung Contact 1986 an der Nägeligasse eröffnet. Es war europaweit der erste Ort, an dem Drogensüchtige offiziell toleriert illegale Substanzen konsumieren konnten. Mit dem Verzicht auf Abstinenzorientierung entsprach das Projekt ganz dem Geist der 80er-Bewegung. Schon Anfangs der 80er-Jahre richteten Autonome in besetzten Häuser Fixerräume ein, allerdings fernab von staatlicher Akzeptanz. Mittlerweile wurde das Fixerstübli an die Hodlergasse verlegt – was den Drogenhändlern im Raum Schützenmatte gute Umsätze beschert.'
  },

  // housing
  {
    name: 'giebel',
    displayName: 'WBG Giebel',
    address: 'Dammweg 43, 3013 Bern',
    positions: p.giebelPositions,
    color: colors.FIRST,
    image: p.giebelPositions[0].imgSrc,
    text:
      'Die Wohnbaugenossenschaft Giebel besteht mit Sitz in Bern seit 1985. Die WBG hat sich zum Ziel gesetzt, ökologischen und kostengünstigen Wohnraum zu schaffen – der selbtsverwaltet belebt wird. Allerdings konnte die die Genossenschaft erst 1996 die Liegenschaft am Dammweg 43 im Baurecht erwerben. <br /> <br />Seit 1998 ist das Haus von rund dreissig Personen in sieben Wohnparteien belegt. Neben Zweipersonenhaushalten gibt es Familienwohnungen und Wohngemeinschaften. Im Erdgeschoss befinden sich das weitherum bekannte Gastronomie- und Veranstaltungslokal «Café Kairo» und der Waschsalon «JetWash». Quelle: <a href="http://www.agwohnen.ch/index.php?id=46" target="_blank">agwohnen.ch</a>'
  },
  {
    name: 'qHof',
    address: 'Quartierhof 8, 3013 Bern',
    displayName: 'Q-Hof',
    positions: p.qHofPositions,
    color: colors.SECOND,
    image: p.qHofPositions[0].imgSrc,
    text:
      'Der Q-Hof wechselte zwar erst 1996 in den Besitz (Baurecht) der in den 1980er-Jahren gegründeten Wohnbaugenossenschaft. Bereits in den frühen 80er-Jahren organisierten sich aber die Bewohnerinnen und Bewohner und verhinderten durch politische Vorstösse und direkte Aktionen den Abbruch der Liegenschaften. Der Q-Hof wurde dadurch zum Sinnbild für den Kampf gegen Wohnungsnot und für die Realisierung neuer Wohnfomen. <br /> <br /> Neben rund 30 grösseren und kleineren Wohnungen beherbergt der Q-Hof heute auch den Q-Laden, der selbstverwaltet Bio-, Fair-Trade- und regionale Produkte verkauft. Quelle: <a href="http://www.agwohnen.ch/index.php?id=27" target="_blank">agwohnen.ch</a>'
  },
  {
    name: 'murifeld',
    address: 'Murifeld, 3006 Bern',
    displayName: 'Murifeld',
    positions: p.murifeldPositions,
    color: colors.THIRD,
    image: p.murifeldPositions[0].imgSrc,
    text:
      'Die Mieterschaft des Murifelds hat sich im Jahre 1986 zusammengeschlossen, um sich gegen die angekündigte uniforme Sanierung der Häuser durch die städtische Liegenschaftsverwaltung vehement und damals noch recht kämpferisch zur Wehr zu setzen. <br /> <br /> In den Stadtwohnungen leben viele Künstler und Alt-80er. Noch heute ist die Mieterschaft gut organisiert und bestimmt in offizieller Absprache mit Behörden und Verwaltung einen grossen Teil des Siedlungslebens mit. Quelle: <a href="http://murifeld.ch/" target="_blank">murifeld.ch</a>'
  },
  {
    name: 'zaffaraya',
    address: 'Neufeld, 3012 Bern',
    displayName: 'Zaffaraya',
    positions: p.zaffarayaPositions,
    color: colors.FOURTH,
    image: p.zaffarayaPositions[0].imgSrc,
    text:
      'Der Kampf um das «Freie Land Zaffaraya» – ein Zelt- und Wagendorf auf dem Gaswerkareal – war prägende für die zweite Hälfte der 1980er Jahre in Bern. Die polizeiliche Räumung im November 1987 trug Tausende Menschen auf die Strassen und gilt heute als eines der folgenreichsten Ereignisse der jüngeren Stadtberner Geschichte. 1989 kam es im Neufeld zu einer Wiedereröffnung des Zaffaraya. Noch heute – einen weiteren Umzug später – existiert das Hüttendorf im Neufeld.'
  },
  {
    name: 'viaFelsenau',
    address: 'Spinnereiweg 17, 3004 Bern',
    displayName: 'Via Felsenau',
    positions: p.viaFelsenauPositions,
    color: colors.FIFTH,
    image: p.viaFelsenauPositions[0].imgSrc,
    text: `Auch die Wohnbaugenossenschaft Via Felsenau geht aus der 80er-Bewegung hervor.
      Bereits 1984 gründete eine Gruppe Jugendlicher die Interessengemeinschaft Berner Jugend baut. Der Verein wird 1989 in die Genossenschaft umgewandelt und erhält die Baubewilligung von der Stadt Bern. <br /> <br /> Die Genossenschaft hat noch immer den Zweck, selbstbestimmten, ökologischen und gemeinnützigen Wohnraum zu schaffen. Das erste Projekt, das Gemeinschaftshaus, besteht vor allem aus Lehm und Holz und wurde 1989 mehrheitlich im Selbstbau von rund 50 jungen Leuten erstellt. Das Haus wird von sechs Wohngemeinschaften à fünf Personen bewohnt und stellt nebst privaten auch öffentliche Gemeinschaftsbereiche in einer Glaspyramide und einem Konzert- und Tanzsaal zur Verfügung. <br /> <br /> Die zweite Etappe der Via Felsenau ist ein abgestuft in den Hang gebautes Niedrigenergiegebäude vornehmlich aus Holz und Papierisolation. Die 2002 erstellten 20 2½ bis 5½ -Zimmerwohnungen werden grossenteils von Familien bewohnt. <br /> <br /> Ihnen stehen unter anderem ein Spielfeld, ein Robinson Kinderspielplatz, ein Schrebergarten, eine Bastelbaracke und ein Gemeinschaftshaus zur Verfügung. Quellen: <a href="http://www.viafelsenau.org/" target="_blank">viafelsenau.org</a> und <a href="http://www.agwohnen.ch/index.php?id=44" target="_blank">agwohnen.ch</a>`
  },
  {
    name: 'aarestrand',
    address: 'Greyerzstrasse 50, 3013 Bern',
    displayName: 'WBG Aarestrand',
    positions: p.aarestrandPositions,
    color: colors.SIXTH,
    image: p.aarestrandPositions[0].imgSrc,
    text:
      'Die Genossenschaft Aarestrand wurde 1980 gegründet, um preisgünstigen Wohnraum für ihre Mitglieder zu schaffen. 1981 konnte sie das fünfstöckige Mehrfamilienhaus an der Greyerzstrasse 50 erwerben. Das Haus wurde so umgebaut, dass im Parterre Gemeinschaftsräume (inkl. Gemeinschaftsküche) entstanden, in den oberen Stöcken wurden 23 Zimmer bezogen. <br /> <br /> Heute leben 19 Personen im Haus. Die Wohngemeinschaft setzt sich heute aus BewohnerInnen im Alter zwischen 0 und ü50 zusammen. Seit jeher fördern wir das Zusammenleben verschiedener Generationen und insbesondere mit Kindern. Quelle: <a href="http://www.agwohnen.ch/index.php?id=19" target="_blank">agwohnen.ch</a>'
  },

  // hood
  {
    name: 'breitschTraff',
    address: 'Breitenrainplatz 27, 3014 Bern',
    displayName: 'Breitsch-Träff',
    positions: p.breitsTraffPositions,
    color: colors.FIRST,
    image: p.breitsTraffPositions[0].imgSrc,
    text:
      'Der Breitsch-Träff nahm am 8. November 1980 den Betrieb auf. Das Quartier-Komitee, welches den Treffpunkt erstritt, ging aus dem (erfolglosen) Kampf für den Erhalt des Quartierrestaurants Spitz hervor, im Zuge dessen es sogar zu einer temporären Besetzung kam. Die Idee des Breitsch-Träffs war, ein Begegnungs- und Versammlungsort für die Quartierbevölkerung zu schaffen. <br /> <br /> Bis heute kämpfen Alt-80er für den Erhalt des nach wie vor bestehenden Quartierzentrums, wenn es wieder mal von der Schliessung bedroht ist. Quelle: <a href="https://www.breitsch-traeff.ch" target="_blank">breitsch-traeff.ch</a>'
  },
  {
    name: 'villaStucki',
    address: 'Seftigenstrasse 11, 3007 Bern',
    displayName: 'Villa Stucki',
    positions: p.villaStuckiPositions,
    color: colors.SECOND,
    image: p.villaStuckiPositions[0].imgSrc,
    text:
      'Am 15. November 1980 besetzte eine Hand voll Jugendliche das herrschaftliche Gebäude und erklärte es kurzerhand zum «Autonomen Jugendzentrum». Ein Grossaufgebot der Polizei bereitete dem Spuk nach bloss einer Stunde ein jähes Ende. 1981 gründeten Quartierbewohnerinnen und -Bewohner den Verein Villa Stucki und führen seither mit Unterstützung des Vereins Berner Gemeinwesenarbeit VBG einen Quartiertreffpunkt in der Villa. Quelle: <a href="https://www.villastucki.ch" target="_blank">villastucki.ch</a>'
  },
  {
    name: 'labigiLorraine',
    address: 'Jurastrasse, 3013 Bern',
    displayName: 'Läbigi Lorraine',
    positions: p.labigiLorrainePositions,
    color: colors.THIRD,
    image: p.labigiLorrainePositions[0].imgSrc,
    text:
      'Der Verein «Läbigi Lorraine» wurde zu Beginn der 80er-Jahre mit dem Ziel gegründet, der Alternativszene im Quartier eine Stimme zu verschaffen. Nicht nur die Gründungszeit der Läbigi Lorraine, auch ihre ideellen Wurzeln liegen in den 80er-Jahren, das heisst in der 80er-Bewegung. Es ist die erste Quartierorganisation dieser Art, weitere folgten.<br /> <br /> Lange galt er als Gegengewicht zum bürgerlich-konservativ geprägten Lorraine-Leist. Noch immer setzt er sich für ein durchmischtes Quartier mit preisgünstigen Wohnungen ein. Quelle: <a href="http://www.lorraine.ch" target="_blank">lorraine.ch</a>'
  },

  // youth
  {
    name: 'bronx',
    address: 'Neufeldstrasse 6, 3012 Bern',
    displayName: 'Jugendtreff Bronx',
    positions: p.bronxPositions,
    color: colors.FIRST,
    image: p.bronxPositions[0].imgSrc,
    text:
      'In den 80er-Jahren forderten bewegungsnahe Kreise häufig niederschwellige Treffpunkte für Jugendliche in den Quartieren. Meistens bildeten Jugendliche und engagierte Erwachsene Betriebsgruppen, während Stadt und Kirchen den Betrieb alimentierten. Auch der Jugendtreff Bronx stammt aus dieser Zeit – und ist noch immer in Betrieb. Mittlerweile ist er in die Strukturen der Stadt eingebunden.'
  },
  {
    name: 'juko',
    displayName: 'Jugendkonferenz (Juko)',
    address: 'Postfach 324, 3000 Bern 22',
    positions: p.jukoPositions,
    color: colors.SECOND,
    image: p.jukoPositions[0].imgSrc,
    text:
      'Die Juko (Jugendkonferenz) Bern entstand 1981 als Verein für soziale und kulturelle Arbeit und wurde von engagierten Jugendlichen und Erwachsenen gegründet. Er gilt als institutioneller Vorreiter in Sachen offene Jugendarbeit. Anfänglich gründeten die Mitglieder Arbeitsgruppen, die sich etwa mit dem Waldsterben auseinandersetzten und entsprechende Projekte initiierten. <br /> <br />Mittlerweile ist die offene Jugendarbeit in der Stadt Bern professionalisiert und unter dem Dach der TOJ (Trägerverein für die offene Jugendarbeit der Stadt Bern) organisatorisch zusammengefasst. Die Juko Bern existiert aber weiterhin und führt zusammen mit Jugendlichen noch immer soziale und kulturelle Projekte durch. Das wohl bekannteste Projekt der Juko ist das gggfon - eine Informations- und Beratungsstelle gegen Gewalt und Rassismus. Quelle: <a href="https://www.juko.ch" target=_"blank">http://www.juko.ch/</a>'
  },
  {
    name: 'spielewerkstatt',
    address: 'Wankdorffeldstrasse 104, 3014 Bern',
    displayName: 'Spielewerkstatt',
    positions: p.spielewerkstattPositions,
    color: colors.THIRD,
    image: p.spielewerkstattPositions[0].imgSrc,
    text:
      '1986 gründete der Sozialplaner Martin Baud die Berner Spielewerkstatt. Sie entspricht dem Geist der offenen Kinderarbeit, die in den 1980er Jahren massiv an Popularität gewann. Baud war auch eine treibende Kraft hinter dem Schützenmatt-Spielplatz im Breitenrainquartier. Die Spielewerkstatt verleiht Spielmaterial, organisiert Spielanlässe und berät Eltern, Vereine und Behörden. Quelle: <a href="https://www.spielewerkstatt.ch" target="_blank">spielewerkstatt.ch</a>'
  },
  {
    name: 'schutzenweg',
    address: 'Allmendstrasse 21, 3014 Bern',
    displayName: 'Schützenweg',
    positions: p.schutzenwegPositions,
    color: colors.FOURTH,
    image: p.schutzenwegPositions[0].imgSrc,
    text:
      'Offiziell nahm der Schützenweg-Spielplatz 1985/86 den Betrieb auf. Er entspricht dem freien Geist der 80er-Jahre und geht auf das Engagement von Anwohnern zurück. Allerdings wurde die Brache bereits vorher von Kindern zum Spielen und Jugendlichen zum rumlungern benutzt. Noch heute ist der Abenteuerspielplatz ein gut besuchter Treffpunkt von Kindern und Eltern im Quartier.'
  },
  {
    name: 'graffiti',
    address: 'Scheibenstrasse 64, 3014 Bern',
    displayName: 'Jugendtreff Graffiti',
    positions: p.graffitiPositions,
    color: colors.FIFTH,
    image: p.graffitiPositions[0].imgSrc,
    text:
      'Das Jugendzentrum Bern geht direkt auf die 80er-Bewegung zurück. Jugendliche bauten damals mit Hilfe eines Architekten den Treff weitgehend selber aus recycelten Bauabfällen. Mittlerweile ist das Graffiti von der Scheibenstrasse 72 an die Scheibenstrasse 64 umgezogen und nennt sich Newgraffiti. Obwohl es mittlerweile in die offizielle Jugendarbeit der Stadt eingegliedert ist, orientiert sich der Treff noch immer an gewissen Überzeugungen der Anfangszeiten. So sind etwa sexistische, rassistische oder gewaltverherrlichende Sprayereien verboten. Quelle: BZ'
  }
]
